"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_tutorial = exports.getIsSkipped = exports.signalSkip = void 0;
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageIndicators_sidecar_1 = require("@voyage/ui-cursors/voyageIndicators-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageUiTutorial_sidecar_1 = require("@voyage/ui/voyageUiTutorial-sidecar");
var namespace = 'voyage-game-tutorial';
var _skipTutorial = true; // && voyageTestParams.isDevMode
var _superSkipTutorial = _skipTutorial; //  && voyageTestParams.isDevMode
function signalSkip(superSkip) {
    if (superSkip === void 0) { superSkip = false; }
    _skipTutorial = true;
    _superSkipTutorial = superSkip;
    // voyageUiTutorial.setOpen(false)
}
exports.signalSkip = signalSkip;
function getIsSkipped() {
    return _skipTutorial;
}
exports.getIsSkipped = getIsSkipped;
function gen_selectCrew(ind, cr, title) {
    var text;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (_skipTutorial) {
                    return [2 /*return*/, 0];
                }
                text = 'Select crewmember ' + cr.name + '\n\n(Click highlighted circle to select)';
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText(title, text);
                _a.label = 1;
            case 1:
                if (!(voyagePicker_sidecar_1.voyagePicker.get().selectedCrew !== cr)) return [3 /*break*/, 3];
                voyageIndicators_sidecar_1.voyageIndicators.moveToIJ(ind, cr);
                if (_skipTutorial) {
                    return [2 /*return*/, 0];
                }
                return [4 /*yield*/, 0];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [4 /*yield*/, voyageUiTutorial_sidecar_1.voyageUiTutorial.completeStep()];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function gen_moveToSystem(ind, cr, sysTag) {
    var sys;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (_skipTutorial) {
                    return [2 /*return*/, 0];
                }
                sys = voyageSystems_sidecar_1.voyageSystems.findSystem(sysTag);
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText('Great!', 'Move crewmember ' +
                    cr.name +
                    ' to the indicated ' +
                    ((_a = sys.system) === null || _a === void 0 ? void 0 : _a.data.name) +
                    '\n\n(Click highlighted system to move)');
                _b.label = 1;
            case 1:
                if (!(distanceUtil_sidecar_1.distanceUtil.distanceSimpleIIJ(cr, sys) !== 0)) return [3 /*break*/, 5];
                if (_skipTutorial) {
                    return [2 /*return*/, 0];
                }
                voyageIndicators_sidecar_1.voyageIndicators.moveToIJ(ind, sys);
                if (!(voyagePicker_sidecar_1.voyagePicker.get().selectedCrew !== cr)) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(gen_selectCrew(ind, cr, 'Please select this crewmember'))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [4 /*yield*/, 0];
            case 4:
                _b.sent();
                return [3 /*break*/, 1];
            case 5: return [4 /*yield*/, voyageUiTutorial_sidecar_1.voyageUiTutorial.completeStep()];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function generator_tutorial() {
    var crew, cameraX, cameraY, ind, breach;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log(namespace, 'starting tutorial');
                _a.label = 1;
            case 1:
                if (!!voyageShipSaver_sidecar_1.voyageShipSaver.getIsLoaded()) return [3 /*break*/, 3];
                return [4 /*yield*/, 0];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3:
                crew = imports_1.l.filter(diveCrew_sidecar_1.diveCrew.getAll(), function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero; });
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setOpen(true);
                // assert.notNil(firstCrew, 'No crew!')
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText('Welcome to the battleship Dawn Star', "Use W,A,S,D or hold down the middle mouse button to move the camera\n\n(Move camera to continue)");
                cameraX = voyageCamera_sidecar_1.voyageCamera.get().cameraX;
                cameraY = voyageCamera_sidecar_1.voyageCamera.get().cameraY;
                _a.label = 4;
            case 4:
                if (!(cameraX === voyageCamera_sidecar_1.voyageCamera.get().cameraX &&
                    cameraY === voyageCamera_sidecar_1.voyageCamera.get().cameraY)) return [3 /*break*/, 6];
                if (_skipTutorial) {
                    return [3 /*break*/, 6];
                }
                return [4 /*yield*/, 0];
            case 5:
                _a.sent();
                return [3 /*break*/, 4];
            case 6: return [4 /*yield*/, voyageUiTutorial_sidecar_1.voyageUiTutorial.completeStep()];
            case 7:
                _a.sent();
                ind = voyageIndicators_sidecar_1.voyageIndicators.create();
                return [5 /*yield**/, __values(gen_selectCrew(ind, crew[0], 'Get life support up and running'))];
            case 8:
                _a.sent();
                return [5 /*yield**/, __values(gen_moveToSystem(ind, crew[0], 'life-support-up'))];
            case 9:
                _a.sent();
                return [5 /*yield**/, __values(gen_selectCrew(ind, crew[1], 'Get power support up and running'))];
            case 10:
                _a.sent();
                return [5 /*yield**/, __values(gen_moveToSystem(ind, crew[1], 'reactor-1'))];
            case 11:
                _a.sent();
                return [5 /*yield**/, __values(gen_selectCrew(ind, crew[2], 'Check sensors'))];
            case 12:
                _a.sent();
                return [5 /*yield**/, __values(gen_moveToSystem(ind, crew[2], 'sensor-internal'))];
            case 13:
                _a.sent();
                if (!!_skipTutorial) return [3 /*break*/, 17];
                voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.hitByWeapon(1, 0, 100);
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText('Oh no, a hull breach!', "Fires and hull breaches are fixed by moving crew NEXT to them. Careful, fires are dangerous.");
                breach = imports_1.l.filter(diveCrew_sidecar_1.diveCrew.getAll(), function (c) { return c.type === diveCrew_1.EVoyageCrewType.HullBreach; });
                if (!(breach.length > 0)) return [3 /*break*/, 17];
                voyageIndicators_sidecar_1.voyageIndicators.moveToIJ(ind, breach[0]);
                _a.label = 14;
            case 14:
                if (!!breach[0].isDead) return [3 /*break*/, 16];
                return [4 /*yield*/, 0];
            case 15:
                _a.sent();
                return [3 /*break*/, 14];
            case 16:
                voyageUiTutorial_sidecar_1.voyageUiTutorial.completeStep();
                _a.label = 17;
            case 17:
                voyageIndicators_sidecar_1.voyageIndicators.kill(ind);
                if (!!_skipTutorial) return [3 /*break*/, 19];
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText('Advanced Controls', 'Space - pause\nTab - switch crewmember\nMouse wheel - zoom\nRight-click - deselect ');
                return [4 /*yield*/, 5];
            case 18:
                _a.sent();
                _a.label = 19;
            case 19:
                if (!!_superSkipTutorial) return [3 /*break*/, 23];
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText('Tutorial complete!', 'The ship is yours, commander');
                if (!_skipTutorial) return [3 /*break*/, 21];
                return [4 /*yield*/, 2];
            case 20:
                _a.sent();
                return [3 /*break*/, 23];
            case 21: return [4 /*yield*/, 5];
            case 22:
                _a.sent();
                _a.label = 23;
            case 23:
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setText('', '');
                voyageUiTutorial_sidecar_1.voyageUiTutorial.setOpen(false);
                console.log(namespace, 'ending tutorial');
                // voyageIndicators.moveToXY(ind, 100, 100)
                return [2 /*return*/, 0];
        }
    });
}
exports.generator_tutorial = generator_tutorial;
